// extracted by mini-css-extract-plugin
export default {"StickyBlock":"ben_a bhn_bj"};